import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from '@heroicons/react/24/solid';
import { Link, useLocation } from 'react-router-dom';

const AuthLayout = ({ children, heading, sub }) => {
  const location = useLocation();
  const isLoginPage = location.pathname === '/login';
  const isRegisterPage = location.pathname === '/register';

  return (
    <div className="min-h-screen flex flex-col">
      {/* Navbar */}
      <nav className="bg-white/95 backdrop-blur-lg border-b border-gray-200 shadow-sm sticky top-0 z-40">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            {/* Logo */}
            <Link
              to="/"
              className="flex items-center space-x-2 text-indigo-600 font-bold text-lg hover:text-indigo-800 transition-colors"
            >
              <ShieldCheckIcon className="h-6 w-6" />
              <span>IRSAudit</span>
            </Link>

            {/* Navigation Links */}
            <div className="hidden md:flex items-center space-x-8">
              <Link
                to="/"
                className="text-gray-600 hover:text-gray-900 transition-colors font-medium"
              >
                Home
              </Link>
              <Link
                to="/intake"
                className="text-gray-600 hover:text-gray-900 transition-colors font-medium"
              >
                Get Started
              </Link>
            </div>

            {/* Action Buttons */}
            <div className="flex items-center space-x-4">
              {isLoginPage ? (
                <Link
                  to="/register"
                  className="text-gray-600 hover:text-gray-900 font-medium transition-colors"
                >
                  Create Account
                </Link>
              ) : isRegisterPage ? (
                <Link
                  to="/login"
                  className="text-gray-600 hover:text-gray-900 font-medium transition-colors"
                >
                  Sign In
                </Link>
              ) : (
                <Link
                  to="/login"
                  className="text-gray-600 hover:text-gray-900 font-medium transition-colors"
                >
                  Sign In
                </Link>
              )}
              <Link
                to="/intake"
                className="bg-blue-600 text-white px-6 py-2 rounded-lg font-semibold hover:bg-blue-700 transition-colors shadow-sm"
              >
                Get Protected
              </Link>
            </div>
          </div>
        </div>
      </nav>

      {/* Main Content */}
      <div className="flex flex-1 lg:flex-row">
        {/* Illustration */}
        <div className="hidden lg:flex w-1/2 bg-gradient-to-br from-indigo-600 to-purple-600 items-center justify-center p-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-white flex flex-col items-center"
          >
            <ShieldCheckIcon className="h-20 w-20 mb-4" />
            <h2 className="text-3xl font-bold mb-2 text-center">IRSAudit</h2>
            <p className="text-center max-w-sm">Over 1,200 businesses protected 🛡️</p>
          </motion.div>
        </div>

        {/* Form card */}
        <div className="flex-1 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8 bg-gray-50">
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.3 }}
            className="max-w-md w-full space-y-8 bg-white p-10 rounded-2xl shadow-xl"
          >
            <div>
              <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">{heading}</h2>
              {sub && <p className="mt-2 text-center text-sm text-gray-600">{sub}</p>}
            </div>
            {children}
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout; 